import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.2_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/[locale]/providers.tsx");
